// ANGULAR MODULE
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
// THIRD PARTY MODULE
import { CountdownModule } from 'ngx-countdown';

import { TranslationModule } from './translation/translation.module';

// WALLET ACCOUNT SHARED MODULE
import { PaperOtpModule } from './shared/paper-otp/paper-otp.module';
import { PaperCurrencyModule } from './shared/pipes/paper-currency/paper-currency.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// WALLET ACCOUNT CORE
import { WalletPinModuleProvider } from './core/helpers/provider/module/wallet-pin-module.provider';
import { WalletAccountCoreModule } from './core/wallet-account-core.module';

// HTTP INTERCEPTORS
import { httpErrorInterceptor } from './core/services/interceptor/http-error.interceptor';

// SINGLETON SERVICES
import { JwtProcessingService } from './core/services/jwt-processing/jwt-processing.service';
import { WalletPinMockConfigService } from './core/services/wallet-pin-mock-config/wallet-pin-mock-config.service';

@NgModule({
    declarations: [AppComponent],
    imports: [
        TranslationModule,
        BrowserModule,
        AppRoutingModule,
        WalletAccountCoreModule.forRoot(),
        PaperOtpModule,
        CountdownModule,
        PaperCurrencyModule,
    ],
    providers: [
        ...WalletPinModuleProvider,
        JwtProcessingService,
        WalletPinMockConfigService,
        provideHttpClient(withInterceptors([httpErrorInterceptor])),
        provideAnimations(),
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
